
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { LoadEmailConfigurationState, LoadEmailConfigurationStateSuccess, LoadEmailConfigurationStateFail, EmailConfigurationActionTypes, SubmitEmailTemplate } from './email-configuration.actions';
import { LGEDataService } from '../../../commons';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, startWith, switchMap } from 'rxjs';

@Injectable()
export class EmailConfigurationEffects {
  SubmitEmailTempate$ = createEffect(
    () => this.actions$.pipe(
      ofType(EmailConfigurationActionTypes.SubmitEmailTemplate),
      map((action: SubmitEmailTemplate) => action.payload),
      switchMap(
        (data) => from(this.lgeData.EmailTemplateIUD(data)).pipe(
          map(() => new LoadEmailConfigurationState()),
          catchError(error => of(new LoadEmailConfigurationStateFail(error)))
        )
      )
    )
  )
  loadEmailConfig$ = createEffect(
    () => this.actions$.pipe(
      ofType(EmailConfigurationActionTypes.LoadEmailConfigurationState),
      // startWith(new LoadEmailConfigurationState()),
      switchMap(
        () => from(this.lgeData.GetEmailTemplates()).pipe(
          map(data => new LoadEmailConfigurationStateSuccess(data)),
          catchError(error => of(new LoadEmailConfigurationStateFail(error))) 
        )
      )
    )
  )
  // @Effect()
  // SubmitEmailTempate$: Observable<Action> = this.actions$
  //   .ofType(EmailConfigurationActionTypes.SubmitEmailTemplate)
  //   // This action happens at startup
  //   .map((action: SubmitEmailTemplate) => action.payload)
  //   .switchMap((data) =>
  //     Observable.fromPromise(this.lgeData.EmailTemplateIUD(data))
  //       .map(() => new LoadEmailConfigurationState())
  //       .catch(error => Observable.of(new LoadEmailConfigurationStateFail(error)))

  //   );

  // @Effect()
  // loadEmailConfig$: Observable<Action> = this.actions$
  //   .ofType(EmailConfigurationActionTypes.LoadEmailConfigurationState)
  //   .startWith(new LoadEmailConfigurationState())
  //   .switchMap(() =>
  //     Observable.fromPromise(this.lgeData.GetEmailTemplates())
  //       .map(data => new LoadEmailConfigurationStateSuccess(data))
  //       .catch(error => Observable.of(new LoadEmailConfigurationStateFail(error)))
  //   );

  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService
  ) { }
}